import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {GameService} from '../game.service';

@Component({
  selector: 'app-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlsComponent implements OnInit {

  constructor(public game: GameService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/tic-tac-toe/controls/controls.component.ts